import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import LargePaper from '../../components/Layout/LargePaper';
import { ROLE_USER } from '../../constants/roles';
import { getBooks } from '../../store/books/actions';
import { getSites } from '../../store/sites/actions';
import withAuthorization from '../../hoc/withAuthorization';
import BookingsTable from '../../components/Bookings/BookingsTable';
import stylesDefault from '../../constants/stylesDefault';

export class BookingsPage extends Component {

  state = {
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;

    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
      if (!props.books && !props.pendingBooks && !props.errorBooks) {
        props.getBooks(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites && !props.errorSites) {
        props.getSites(props.authUser.ma, role);
      }
    }
    return newState;
  }

  render() {
    return (
      <LargePaper>
        <h1 style={stylesDefault.title}>Réservations</h1>
        <BookingsTable
          books={this.props.books}
          pending={this.props.pending}
        />
      </LargePaper>
    );
  }
}

const authCondition = authUser => !!authUser;

const mapStateToProps = state => ({
  authUser: state.users.authUser,
  roles: state.roles.content,
  pending: state.sites.pending || state.books.pending,
  sites: state.sites.content,
  books: state.books.content,
  pendingSites: state.sites.pending,
  pendingBooks: state.books.pending,
  errorSites: state.sites.error,
  errorBooks: state.books.error,
});

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, { getBooks, getSites }),
)(BookingsPage);



// WEBPACK FOOTER //
// ./src/containers/Bookings/BookingsPage.jsx